var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Alert, Typography } from '@mui/material';
import styled from 'styled-components';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 20px 30px;\n"], ["\n  margin: 20px 30px;\n"])));
var RoasterContactPage = function () {
    var t = useTranslation().t;
    return (React.createElement(Wrapper, null,
        React.createElement(Grid, { container: true, alignItems: "center", justifyContent: "center", direction: "column", spacing: 3 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Alert, { severity: "info" }, t('messages.contactToTypicaMessage'))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h3" },
                    React.createElement("a", { href: "mailto: ".concat(SYSTEM_MAIL_TO, "?subject=").concat(encodeURIComponent(t('messages.contactToTypicaMailSubject'))) }, SYSTEM_MAIL_TO))))));
};
export default RoasterContactPage;
var templateObject_1;
